import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, Col, Form, FormControl, FormGroup } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import Loadable from 'react-loading-overlay'
import { loadReCaptcha } from 'react-recaptcha-v3'
import { ReCaptcha } from 'react-recaptcha-v3'
import Validators from '../utils/validators'

@observer(['globals', 'users'])
export default class ResetPassword extends Component {

  constructor(props) {
    super(props)

    this.state = {
      newPassword: '',
      confirmPassword: '',
      loadableState: true,
      loadableMessage: 'Checking reset token validity...'
    }

    document.body.className = 'login'
    document.body.style.backgroundColor = '#eee'
  }

  componentDidMount() {
    loadReCaptcha('6LfGdKAUAAAAAFtHSKJwnMWn9UcwFdcLVYFqq6bF');

    if (this.props && this.props.resetToken.length > 0) {
      this.props.users.checkResetToken(this.props.resetToken, (data) => {
        if(data.checkResetToken && data.checkResetToken.statusCode && data.checkResetToken.statusCode == 400) {
          this.setState({
            loadableMessage: 'Invalid password reset token.  Please request a new one and follow the link provided in the email to reset your password.'
          })
        } else {
          this.setState({
            loadableMessage: '',
            loadableState: false
          })
        }
      })
    } else {
      this.setState({
        loadableMessage: 'No password reset token found.  Please request a password reset token or use the link provided in the password reset email.'
      });
    }
  }

  editNewPassword(e) {
    this.setState({
      newPassword: e.target.value
    })
  }

  editConfirmPassword(e) {
    this.setState({
      confirmPassword: e.target.value
    })
  }

  handleResetPasswordClick() {
    if (this.props && this.props.resetToken.length > 0) {
      if (this.validateNewPasswordForm()) {
        if (this.verifyPasswordsMatchState()) {
          this.props.users.resetPassword(this.props.resetToken, this.state.newPassword, (data) => {
            alert(data.resetPassword.data.message);
            browserHistory.push('/');
          })
        }
        else {
          alert('Your password do not match.  Please try again.')
        }
      }
      else {
        alert('Please enter and confirm your new password.  Password my be at least 5 character.');
      }
    }
    else {
      alert('There is a problem with your request.  Please start over by clicking the password reset email you received.  If you did not receive an email you must request one from the main login page.')
    }
  }

  returnToLogin() {
    browserHistory.push('/');
  }

  validateNewPasswordForm() {
    if (this.getNewPasswordValidationState() == 'error') {
      return false;
    }

    if (this.getConfirmPasswordValidationState() == 'error') {
      return false;
    }

    return true;
  }

  getNewPasswordValidationState() {
    if (this.state && Validators.validString(this.state.newPassword) && this.state.newPassword.length >= 5) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getConfirmPasswordValidationState() {
    if (this.state && Validators.validString(this.state.confirmPassword) && this.state.confirmPassword.length >= 5) {
      return 'success'
    } else {
      return 'error'
    }
  }

  verifyPasswordsMatchState() {
    if (this.state && this.state.newPassword && this.state.confirmPassword && this.state.newPassword == this.state.confirmPassword) {
      return true;
    }
    
    return false;
  }

  render() {

    return (
      <div className="login">
        <div>
          <div className="login_wrapper">
            <div className="animate form login_form">
              <section className="login_content">
              <img alt="GPS Leaders" src="/images/logo-white.png" /><br />
                <Loadable active={ this.state.loadableState } spinner text={ this.state.loadableMessage }>
                  <Form>
                    <h1>Reset Password</h1>
                    <Col>
                      <FormGroup validationState={this.getNewPasswordValidationState()}>
                        <FormControl id="newPassword" style={
                          {
                            height: "34px",
                            paddingLeft: "12px",
                            paddingRight: "12px",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            backgroundColor: "#FFF"
                          }
                        } type="password" className="form-control" placeholder="New Password" required="" onChange={ this.editNewPassword.bind(this) } />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup validationState={this.getConfirmPasswordValidationState()}>
                        <FormControl id="confirmPassword" style={
                          {
                            height: "34px",
                            paddingLeft: "12px",
                            paddingRight: "12px",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            backgroundColor: "#FFF"
                          }
                        } type="password" className="form-control" placeholder="Confirm Password" required="" onChange={ this.editConfirmPassword.bind(this) } />
                      </FormGroup>
                    </Col>
                    <Col>
                      <ReCaptcha
                        sitekey="6LfGdKAUAAAAAFtHSKJwnMWn9UcwFdcLVYFqq6bF"
                      />
                    </Col>
                    <Col>
                      <Button onClick={ this.handleResetPasswordClick.bind(this) }>Reset Password</Button>
                    </Col>
                  </Form>
                </Loadable>
                <div className="clearfix"></div>
                <div className="separator">
                  <div className="clearfix"></div>
                  <div>
                    <h2>GPS Leaders CRM</h2>
                    <Button onClick={ this.returnToLogin.bind(this) }>Return to Login Page</Button>
                    <p>©2019 All Rights Reserved. This is a GPS Leaders product.</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/passwordreset.js